export const CharacterIcon = ({...props}) => {
    return (
        <svg
            width="5"
            height="14"
            viewBox="0 0 5 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x="0.5" width="4" height="14" rx="2"/>
        </svg>
    );
}